import styled from 'styled-components';

export const ErrorMessage = styled.div`
  position: relative;
  margin: 1em 0em;
  padding: 1em 1.5em;
  color: #9f3a38;
  background-color: #fff6f6;
`;

export const ErrorMessageHeader = styled.div`
  font-weight: 600;
  color: #912d2b;
  padding-bottom: 0.5em;
`;
